<script setup lang="ts">
import { ErrorMessage } from 'vee-validate';

defineProps<{
    fieldName: string;
}>();
</script>
<template>
    <ErrorMessage :name="fieldName" as="span" class="text-sm text-red-400" />
</template>
